import { useT } from "@/i18n/useTranslation";

/**
 * Renders a navigation label from an i18n key with a guaranteed fallback.
 * Prevents raw keys (e.g. "nav.search") from leaking to the UI when a
 * translation is missing.
 */
interface NavLabelProps {
  /** i18n key, e.g. "nav.search" */
  tKey: string;
  /** Mandatory human fallback if the key is missing */
  fallback: string;
  className?: string;
}

export const NavLabel = ({ tKey, fallback, className }: NavLabelProps) => {
  const { t } = useT();
  const value = t(tKey);
  const safe = value && value !== tKey ? value : fallback;
  return <span className={className}>{safe}</span>;
};

/** Hook variant when a string (not JSX) is needed. */
export const useNavLabel = () => {
  const { t } = useT();
  return (tKey: string, fallback: string) => {
    const value = t(tKey);
    return value && value !== tKey ? value : fallback;
  };
};

export default NavLabel;